// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-layout {
  min-height: 100vh;
}

.admin-sider {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
}

.admin-sider .ant-layout-sider-children {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.admin-logo {
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-title {
  color: white !important;
  margin: 0 !important;
  font-size: 16px;
  font-weight: 600;
}

.admin-menu {
  flex: 1 1;
  border-right: none;
}

.admin-menu .ant-menu-item {
  margin: 4px 8px;
  border-radius: 6px;
  height: 40px;
  line-height: 40px;
}

.admin-menu .ant-menu-item-selected {
  background: #1890ff !important;
}

.admin-menu .ant-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.admin-menu .ant-menu-item-selected:hover {
  background: #1890ff !important;
}

.admin-main {
  margin-left: 240px;
  transition: margin-left 0.2s;
}

.admin-layout .ant-layout-sider-collapsed + .admin-main {
  margin-left: 80px;
}

.admin-header {
  background: #fff;
  padding: 0 24px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 99;
}

.header-left {
  display: flex;
  align-items: center;
}

.collapse-btn {
  font-size: 18px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.collapse-btn:hover {
  background: #f0f0f0;
}

.header-right {
  display: flex;
  align-items: center;
}

.home-btn {
  color: #666;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.home-btn:hover {
  color: #1890ff;
  background: #e6f7ff;
}

.user-info {
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.user-info:hover {
  background: #f0f0f0;
}

.username {
  color: #262626;
  font-weight: 500;
}

.admin-content {
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.content-wrapper {
  margin: 0 auto;
  background: #fff;
  min-height: calc(100vh - 112px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .admin-sider {
    position: fixed;
    z-index: 1000;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
  
  .admin-sider.mobile-open {
    transform: translateX(0);
  }
  
  .admin-main {
    margin-left: 0;
  }
  
  .admin-layout .ant-layout-sider-collapsed + .admin-main {
    margin-left: 0;
  }
  
  .admin-header {
    padding: 0 16px;
  }
  
  .admin-content {
    padding: 16px;
  }
  
  .content-wrapper {
    min-height: calc(100vh - 96px);
  }
  
  .username {
    display: none;
  }
}

/* 暗色主题适配 */
.admin-layout .ant-layout-sider-dark {
  background: #001529;
}

.admin-layout .ant-menu-dark {
  background: transparent;
}

.admin-layout .ant-menu-dark .ant-menu-item {
  color: rgba(255, 255, 255, 0.85);
}

.admin-layout .ant-menu-dark .ant-menu-item:hover {
  color: #fff;
}

.admin-layout .ant-menu-dark .ant-menu-item-selected {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/Layout/AdminLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,SAAS;EACT,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,aAAa;IACb,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".admin-layout {\n  min-height: 100vh;\n}\n\n.admin-sider {\n  position: fixed;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 100;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);\n}\n\n.admin-sider .ant-layout-sider-children {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.admin-logo {\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  background: rgba(255, 255, 255, 0.1);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logo-title {\n  color: white !important;\n  margin: 0 !important;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.admin-menu {\n  flex: 1;\n  border-right: none;\n}\n\n.admin-menu .ant-menu-item {\n  margin: 4px 8px;\n  border-radius: 6px;\n  height: 40px;\n  line-height: 40px;\n}\n\n.admin-menu .ant-menu-item-selected {\n  background: #1890ff !important;\n}\n\n.admin-menu .ant-menu-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.admin-menu .ant-menu-item-selected:hover {\n  background: #1890ff !important;\n}\n\n.admin-main {\n  margin-left: 240px;\n  transition: margin-left 0.2s;\n}\n\n.admin-layout .ant-layout-sider-collapsed + .admin-main {\n  margin-left: 80px;\n}\n\n.admin-header {\n  background: #fff;\n  padding: 0 24px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n}\n\n.collapse-btn {\n  font-size: 18px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.collapse-btn:hover {\n  background: #f0f0f0;\n}\n\n.header-right {\n  display: flex;\n  align-items: center;\n}\n\n.home-btn {\n  color: #666;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.home-btn:hover {\n  color: #1890ff;\n  background: #e6f7ff;\n}\n\n.user-info {\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n}\n\n.user-info:hover {\n  background: #f0f0f0;\n}\n\n.username {\n  color: #262626;\n  font-weight: 500;\n}\n\n.admin-content {\n  padding: 24px;\n  background: #f5f5f5;\n  min-height: calc(100vh - 64px);\n}\n\n.content-wrapper {\n  margin: 0 auto;\n  background: #fff;\n  min-height: calc(100vh - 112px);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .admin-sider {\n    position: fixed;\n    z-index: 1000;\n    transform: translateX(-100%);\n    transition: transform 0.3s ease;\n  }\n  \n  .admin-sider.mobile-open {\n    transform: translateX(0);\n  }\n  \n  .admin-main {\n    margin-left: 0;\n  }\n  \n  .admin-layout .ant-layout-sider-collapsed + .admin-main {\n    margin-left: 0;\n  }\n  \n  .admin-header {\n    padding: 0 16px;\n  }\n  \n  .admin-content {\n    padding: 16px;\n  }\n  \n  .content-wrapper {\n    min-height: calc(100vh - 96px);\n  }\n  \n  .username {\n    display: none;\n  }\n}\n\n/* 暗色主题适配 */\n.admin-layout .ant-layout-sider-dark {\n  background: #001529;\n}\n\n.admin-layout .ant-menu-dark {\n  background: transparent;\n}\n\n.admin-layout .ant-menu-dark .ant-menu-item {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.admin-layout .ant-menu-dark .ant-menu-item:hover {\n  color: #fff;\n}\n\n.admin-layout .ant-menu-dark .ant-menu-item-selected {\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
